class CustomHeader {
  constructor() {
    this.mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
    this.mobileMenu = document.querySelector('[data-mobile-menu]');
    this.mobileMenuClose = document.querySelectorAll('[data-mobile-menu-close]');
    this.submenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
    this.searchTrigger = document.querySelector('[data-search-trigger]');
    this.mobileSearchTrigger = document.querySelector('[data-mobile-search-trigger]');
    this.searchDrawer = document.querySelector('[data-search-drawer]');
    this.searchInput = document.querySelector('[data-search-input]');
    this.searchClear = document.querySelector('[data-search-clear]');
    this.searchClose = document.querySelectorAll('[data-search-close]');
    this.searchTabs = document.querySelectorAll('.search-tab');
    this.viewAllButton = document.querySelector('[data-view-all]');
    this.countrySelectors = document.querySelectorAll('[data-country-selector]');
    
    this.currentQuery = '';
    this.searchTimeout = null;
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleCartUpdate();
    this.getCurrentCurrency();
  }

  bindEvents() {
    // Desktop search drawer
    if (this.searchTrigger) {
      this.searchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearchDrawer();
      });
    }

    // Mobile search drawer
    if (this.mobileSearchTrigger) {
      this.mobileSearchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearchDrawer();
      });
    }

    // Close search drawer
    if (this.searchClose) {
      this.searchClose.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeSearchDrawer();
        });
      });
    }

    // Close search drawer on overlay click
    if (this.searchDrawer) {
      const overlay = this.searchDrawer.querySelector('.search-drawer-overlay');
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.closeSearchDrawer();
        });
      }
    }

    // Search input
    if (this.searchInput) {
      this.searchInput.addEventListener('input', (e) => this.handleSearchInput(e));
    }

    // Search clear
    if (this.searchClear) {
      this.searchClear.addEventListener('click', (e) => {
        e.preventDefault();
        this.clearSearch();
      });
    }

    // Search tabs
    if (this.searchTabs) {
      this.searchTabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchTab(e);
        });
      });
    }

    // Country selectors - handle form submission
    if (this.countrySelectors) {
      this.countrySelectors.forEach(selector => {
        selector.addEventListener('change', (e) => {
          const form = e.target.closest('form');
          if (form) {
            form.submit();
          }
        });
      });
    }

    // Mobile menu toggle
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.openMobileMenu();
      });
    }

    // Mobile menu close
    if (this.mobileMenuClose) {
      this.mobileMenuClose.forEach(closeBtn => {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeMobileMenu();
        });
      });
    }

    // Submenu toggles
    if (this.submenuToggles) {
      this.submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleSubmenu(e);
        });
      });
    }

    // Close modals on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (this.searchDrawer && this.searchDrawer.classList.contains('active')) {
          this.closeSearchDrawer();
        }
        if (this.mobileMenu && this.mobileMenu.classList.contains('active')) {
          this.closeMobileMenu();
        }
      }
    });

    // Prevent body scroll when modals are open
    this.preventBodyScroll();
  }

  getCurrentCurrency() {
    // Get currency from selected country
    const countrySelector = document.querySelector('[data-country-selector]');
    if (countrySelector) {
      const selectedOption = countrySelector.options[countrySelector.selectedIndex];
      if (selectedOption) {
        // Extract currency from option text: "IN (INR ₹)"
        const match = selectedOption.textContent.match(/\(([A-Z]{3})/);
        if (match && match[1]) {
          this.shopCurrency = match[1];
          return;
        }
      }
    }
    
    // Fallback to Shopify currency
    this.shopCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active 
      ? window.Shopify.currency.active 
      : 'USD';
  }

  openSearchDrawer() {
    if (this.searchDrawer) {
      // Close mobile menu if open
      if (this.mobileMenu && this.mobileMenu.classList.contains('active')) {
        this.closeMobileMenu();
      }
      
      this.searchDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (this.searchInput) {
        setTimeout(() => this.searchInput.focus(), 300);
      }
    }
  }

  closeSearchDrawer() {
    if (this.searchDrawer) {
      this.searchDrawer.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => {
        this.clearSearch();
      }, 300);
    }
  }

  clearSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.currentQuery = '';
    }
    if (this.searchClear) {
      this.searchClear.classList.remove('visible');
    }
    // Clear results
    const productsList = document.querySelector('[data-products-list]');
    const collectionsList = document.querySelector('[data-collections-list]');
    if (productsList) productsList.innerHTML = '';
    if (collectionsList) collectionsList.innerHTML = '';
  }

  handleSearchInput(e) {
    const query = e.target.value.trim();
    
    // Show/hide clear button
    if (this.searchClear) {
      if (query.length > 0) {
        this.searchClear.classList.add('visible');
      } else {
        this.searchClear.classList.remove('visible');
      }
    }

    // Debounce search
    clearTimeout(this.searchTimeout);
    
    if (query.length < 2) {
      this.clearSearchResults();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.performSearch(query);
    }, 300);
  }

  clearSearchResults() {
    const productsList = document.querySelector('[data-products-list]');
    const collectionsList = document.querySelector('[data-collections-list]');
    if (productsList) productsList.innerHTML = '';
    if (collectionsList) collectionsList.innerHTML = '';
  }

  async performSearch(query) {
    this.currentQuery = query;
    
    // Show loading
    const loadingSpinner = document.querySelector('.search-loading');
    if (loadingSpinner) {
      loadingSpinner.style.display = 'flex';
    }

    try {
      // Search for products and collections
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last`);
      const data = await response.json();

      // Hide loading
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }

      // Render products and collections
      if (data.resources && data.resources.results) {
        this.renderProducts(data.resources.results.products || []);
        this.renderCollections(data.resources.results.collections || []);
      }

      // Update view all button
      if (this.viewAllButton) {
        this.viewAllButton.href = `/search?q=${encodeURIComponent(query)}`;
      }

    } catch (error) {
      console.error('Search error:', error);
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }
    }
  }

  renderProducts(products) {
    const productsList = document.querySelector('[data-products-list]');
    if (!productsList) return;

    if (products.length === 0) {
      productsList.innerHTML = '<p class="search-no-results">No products found</p>';
      return;
    }

    const html = products.map(product => {
      const price = this.formatMoney(product.price);
      const image = product.image ? product.image : '';
      
      return `
        <a href="${product.url}" class="search-result-item">
          ${image ? `<img src="${image}" alt="${this.escapeHtml(product.title)}" class="search-result-image" loading="lazy">` : ''}
          <div class="search-result-info">
            <h3 class="search-result-title">${this.escapeHtml(product.title)}</h3>
            <p class="search-result-price">${price}</p>
          </div>
        </a>
      `;
    }).join('');

    productsList.innerHTML = html;
  }

  renderCollections(collections) {
    const collectionsList = document.querySelector('[data-collections-list]');
    if (!collectionsList) return;

    if (collections.length === 0) {
      collectionsList.innerHTML = '<p class="search-no-results">No collections found</p>';
      return;
    }

    const html = collections.map(collection => {
      return `
        <a href="${collection.url}" class="search-result-item collection-item">
          <div class="search-result-info">
            <h3 class="search-result-title">${this.escapeHtml(collection.title)}</h3>
          </div>
        </a>
      `;
    }).join('');

    collectionsList.innerHTML = html;
  }

  switchTab(e) {
    const clickedTab = e.currentTarget;
    const tabName = clickedTab.dataset.tab;

    // Update active tab
    this.searchTabs.forEach(tab => tab.classList.remove('active'));
    clickedTab.classList.add('active');

    // Update active results
    const allResults = document.querySelectorAll('.search-results');
    allResults.forEach(result => result.classList.remove('active'));
    
    const activeResult = document.querySelector(`[data-results="${tabName}"]`);
    if (activeResult) {
      activeResult.classList.add('active');
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    const value = parseFloat(cents) / 100;
    
    // Use the current shop currency
    const currency = this.shopCurrency || 'USD';
    
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(value);
    } catch (error) {
      console.error('Currency format error:', error);
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    }
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  openMobileMenu() {
    if (this.mobileMenu) {
      // Close search drawer if open
      if (this.searchDrawer && this.searchDrawer.classList.contains('active')) {
        this.closeSearchDrawer();
      }
      
      this.mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  closeMobileMenu() {
    if (this.mobileMenu) {
      this.mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  toggleSubmenu(e) {
    const toggle = e.currentTarget;
    const navItem = toggle.closest('.mobile-nav-item');
    
    if (navItem) {
      // Close other expanded items
      const allItems = document.querySelectorAll('.mobile-nav-item.expanded');
      allItems.forEach(item => {
        if (item !== navItem) {
          item.classList.remove('expanded');
        }
      });
      
      navItem.classList.toggle('expanded');
    }
  }

  preventBodyScroll() {
    // Observe mobile menu
    if (this.mobileMenu) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            if (this.mobileMenu.classList.contains('active')) {
              document.body.style.overflow = 'hidden';
            } else if (!this.searchDrawer || !this.searchDrawer.classList.contains('active')) {
              document.body.style.overflow = '';
            }
          }
        });
      });

      observer.observe(this.mobileMenu, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    // Observe search drawer
    if (this.searchDrawer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            if (this.searchDrawer.classList.contains('active')) {
              document.body.style.overflow = 'hidden';
            } else if (!this.mobileMenu || !this.mobileMenu.classList.contains('active')) {
              document.body.style.overflow = '';
            }
          }
        });
      });

      observer.observe(this.searchDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  handleCartUpdate() {
    // Listen for cart updates
    document.addEventListener('cart:updated', (e) => {
      const cartCounts = document.querySelectorAll('.cart-count');
      const itemCount = e.detail?.cart?.item_count || 0;
      
      cartCounts.forEach(count => {
        count.textContent = itemCount;
        count.style.display = itemCount > 0 ? 'flex' : 'none';
      });
    });

    // Update cart count on page load
    this.updateCartCount();
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCounts = document.querySelectorAll('.cart-count');
      
      cartCounts.forEach(count => {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }
}

// Initialize the header when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CustomHeader();
  });
} else {
  new CustomHeader();
}

// Handle dynamic section rendering in theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new CustomHeader();
  });
}
// Mobile Submenu Toggle - Fixed Version
document.querySelectorAll('.mobile-submenu-toggle').forEach(toggle => {
  toggle.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const parentItem = this.closest('.mobile-nav-item');
    const submenu = parentItem.querySelector('.mobile-submenu');
    
    // Close other open submenus
    document.querySelectorAll('.mobile-nav-item.active').forEach(item => {
      if (item !== parentItem) {
        item.classList.remove('active');
        item.querySelector('.mobile-submenu').style.maxHeight = null;
      }
    });
    
    // Toggle current submenu
    parentItem.classList.toggle('active');
    
    if (parentItem.classList.contains('active')) {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
    } else {
      submenu.style.maxHeight = null;
    }
  });
});